import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, memo, useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input, Tag } from 'antd';
import { useContextSelector } from 'use-context-selector';
import Portal from '../../../Portal';
import styled, { css } from '../../../styled';
import LayoutContext from '../../context';
const isMacOS = typeof window !== 'undefined' ? navigator.userAgent.toLowerCase().includes('mac os') : false;
const TopbarSearch = ({ className, disableShortcut, disableEscape, onEnter, status, placeholder = 'Pesquisar' }) => {
    const inputRef = useRef(null);
    const [value, setValue] = useState();
    const container = useContextSelector(LayoutContext, context => context.topbar.centerPortal);
    const onKeyDown = useCallback((event) => {
        const input = event.currentTarget;
        if (!disableEscape && event.key === 'Escape') {
            setValue('');
            input.blur();
            return;
        }
        if (event.key !== 'Enter')
            return;
        onEnter &&
            onEnter(input.value, () => {
                setValue('');
                input.blur();
            });
    }, [disableEscape, onEnter]);
    const onChange = (e) => {
        setValue(e.currentTarget.value);
    };
    useEffect(() => {
        const listener = (e) => {
            if (e.target !== document.body || !inputRef.current)
                return;
            const metaKey = isMacOS ? e.metaKey : e.ctrlKey;
            if (e.key.toLowerCase() !== 'k' || !metaKey)
                return;
            e.preventDefault();
            e.stopPropagation();
            inputRef.current.focus();
        };
        window.addEventListener('keydown', listener);
        return () => {
            window.removeEventListener('keydown', listener);
        };
    }, []);
    if (!container)
        return null;
    return (_jsx(Portal, Object.assign({ target: container }, { children: _jsx("div", Object.assign({ className: className }, { children: _jsx(Input, { ref: inputRef, prefix: _jsx(SearchOutlined, {}), status: status, allowClear: true, placeholder: placeholder, value: value, onChange: onChange, suffix: disableShortcut ? undefined : _jsx(Tag, { children: `${isMacOS ? '⌘' : 'Ctrl'}+K` }), onKeyDown: disableShortcut ? undefined : onKeyDown }) })) })));
};
export default styled(memo(TopbarSearch))(({ theme }) => css `
    display: flex;
    flex: 1;

    ${theme.mediaQuery.down('md')} {
      display: none;
    }
  `);
